import { c as _c } from "react/compiler-runtime";
import { useEffect, type RefObject } from "react";

/**
 * Calls `onClose` when a pointer event lands outside `ref`.
 * No-ops while `enabled` is false.
 */
export function useOutsideClose(ref, enabled, onClose) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] !== enabled || $[1] !== onClose || $[2] !== ref) {
    t0 = () => {
      if (!enabled) {
        return;
      }
      const handlePointerOutside = event => {
        const target = event.target as Node;
        if (ref.current && !ref.current.contains(target)) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handlePointerOutside);
      document.addEventListener("touchstart", handlePointerOutside);
      return () => {
        document.removeEventListener("mousedown", handlePointerOutside);
        document.removeEventListener("touchstart", handlePointerOutside);
      };
    };
    t1 = [enabled, onClose, ref];
    $[0] = enabled;
    $[1] = onClose;
    $[2] = ref;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}